// ============================================================
// COMPONENT GROUPINGS DATA - COMPLETE COVERAGE
// No component left unassigned
// ============================================================

export const COMPONENT_GROUPINGS = {
  
  // ============================================================
  // TYPE-BASED GROUPINGS (Complete - covers ALL components)
  // ============================================================
  
  typeGroups: {
    'hardware': {
      name: 'Hardware & Infrastructure',
      icon: '🔧',
      color: '#f97316',
      description: 'Physical infrastructure and compute resources',
      keywords: ['cpu', 'gpu', 'tpu', 'npu', 'fpga', 'asic', 'neuromorphic', 'quantum', 'analog', 'dram', 'sram', 'hbm', 'cache', 'register', 'ssd', 'hdd', 'flash', 'tape', 'optical', 'ethernet', 'infiniband', 'pcie', 'nvlink', 'antenna', 'fiber', 'power', 'voltage', 'cooling', 'liquid', 'air', 'heat', 'ups', 'uninterruptible', 'server', 'hardware', 'processor', 'memory', 'storage device', 'network'],
      components: [
        'CPU (x86)', 'CPU (ARM)', 'CPU (RISC-V)', 'GPU (NVIDIA)', 'GPU (AMD)',
        'TPU (Google)', 'NPU (Apple Neural Engine)', 'FPGA', 'ASIC',
        'Neuromorphic Chip', 'Quantum Processor', 'Analog Computer',
        'DRAM', 'SRAM', 'HBM (High Bandwidth Memory)', 'CPU Cache (L1/L2/L3)', 'Register Files',
        'SSD (NVMe)', 'SSD (SATA)', 'HDD', 'Flash Storage', 'Tape Drive', 'Optical Storage',
        'Ethernet', 'InfiniBand', 'PCIe Bus', 'NVLink', '5G/Wi-Fi Antennas', 'Fiber Optics',
        'Power Supply Units', 'Voltage Regulators', 'Liquid Cooling', 'Air Cooling',
        'Heat Sinks', 'Uninterruptible Power Supplies'
      ]
    },
    
    'sensors': {
      name: 'Sensors & Interfaces',
      icon: '📡',
      color: '#06b6d4',
      description: 'Environmental interfaces and sensors',
      keywords: ['sensor', 'camera', 'microphone', 'thermometer', 'accelerometer', 'gyroscope', 'gps', 'pressure', 'chemical', 'bio', 'lidar', 'infrared', 'servo', 'stepper', 'hydraulic', 'pneumatic', 'speaker', 'haptic', 'led', 'screen', 'display', 'actuator', 'motor', 'valve'],
      components: [
        'Camera (Visible Light)', 'Camera (Infrared)', 'LIDAR', 'Microphone',
        'Thermometer', 'Accelerometer', 'Gyroscope', 'GPS', 'Pressure Sensor', 'Chemical/Bio Sensor',
        'Servo Motor', 'Stepper Motor', 'Hydraulic/Pneumatic Valves', 'Speaker',
        'Haptic Feedback Motor', 'LED/Screen',
        'REST API', 'Webhook', 'gRPC', 'Bluetooth/BLE', 'USB', 'File Upload',
        'Terminal/CLI Input', 'UI (Mouse/Keyboard/Touch)'
      ]
    },
    
    'data-storage': {
      name: 'Data Storage',
      icon: '💾',
      color: '#8b5cf6',
      description: 'Databases and storage systems',
      keywords: ['database', 'storage', 'sql', 'nosql', 'postgresql', 'mysql', 'mongo', 's3', 'blob', 'couchbase', 'firebase', 'pinecone', 'weaviate', 'milvus', 'pgvector', 'faiss', 'chroma', 'neo4j', 'neptune', 'tigergraph', 'arangodb', 'influxdb', 'timescale', 'prometheus', 'hugging', 'mlflow', 'feature', 'redis', 'memcached', 'data lake', 'warehouse'],
      components: [
        'PostgreSQL', 'MySQL', 'SQL Server', 'SQLite', 'Oracle',
        'MongoDB', 'AWS S3', 'Azure Blob Storage', 'Couchbase', 'Firebase',
        'Pinecone', 'Weaviate', 'Milvus', 'pgvector', 'FAISS', 'Chroma',
        'Neo4j', 'Amazon Neptune', 'TigerGraph', 'ArangoDB',
        'InfluxDB', 'TimescaleDB', 'Prometheus',
        'Hugging Face Hub', 'MLflow Registry',
        'Feature Store (Feast)', 'Feature Store (Tecton)', 'Redis', 'Memcached'
      ]
    },
    
    'data-acquisition': {
      name: 'Data Acquisition',
      icon: '📥',
      color: '#10b981',
      description: 'Data collection and ingestion',
      keywords: ['kafka', 'kinesis', 'mqtt', 'websocket', 'telemetry', 'etl', 'airflow', 'dagster', 'sftp', 'scraper', 'scrapy', 'beautifulsoup', 'sql query', 'batch', 'streaming', 'ingestion', 'collection'],
      components: [
        'Apache Kafka', 'AWS Kinesis', 'MQTT Broker', 'WebSocket', 'Telemetry Agent',
        'SQL SELECT Queries', 'ETL Pipeline (Airflow)', 'ETL Pipeline (Dagster)',
        'SFTP Download', 'Web Scraper (Scrapy)', 'Web Scraper (BeautifulSoup)',
        'Unity/Unreal Simulator', 'GAN Generator', 'Diffusion Model',
        'Procedural Generator', 'Mock API',
        'Labeling Tool (Labelbox)', 'Labeling Tool (Scale AI)',
        'Crowdsourcing (Mechanical Turk)', 'Gamification', 'Expert Annotation'
      ]
    },
    
    'data-processing': {
      name: 'Data Processing & Feature Engineering',
      icon: '🔄',
      color: '#ec4899',
      description: 'Data transformation and feature engineering',
      keywords: ['processing', 'feature', 'cleaning', 'validation', 'transformation', 'encoding', 'tokenization', 'embedding', 'normalization', 'scaling', 'pca', 'augmentation', 'smote', 'prompt', 'rag', 'filtering', 'imputation', 'outlier', 'selection', 'great expectations', 'pandera'],
      components: [
        'Great Expectations', 'Pandera', 'Custom Scripts', 'Null Imputation', 'Outlier Removal',
        'One-Hot Encoding', 'Tokenization (BPE)', 'Tokenization (WordPiece)',
        'Embedding Generation', 'Normalization', 'Log Scaling',
        'PCA', 't-SNE', 'Mutual Information', 'Recursive Feature Elimination', 'Lasso Regularization',
        'Image Rotation/Cropping', 'SMOTE', 'Text Back-translation', 'Audio Noise Injection',
        'Prompt Templates', 'RAG Pipelines', 'Metadata Filtering'
      ]
    },
    
    'model': {
      name: 'Model & Intelligence',
      icon: '🧠',
      color: '#3b82f6',
      description: 'ML models and algorithms',
      keywords: ['model', 'ml', 'algorithm', 'neural', 'network', 'regression', 'classification', 'clustering', 'tree', 'forest', 'svm', 'knn', 'bayes', 'cnn', 'rnn', 'lstm', 'transformer', 'gan', 'vae', 'diffusion', 'reinforcement', 'dqn', 'ppo', 'a3c', 'actor', 'bandit', 'search', 'monte', 'genetic', 'annealing', 'swarm', 'bagging', 'boosting', 'stacking', 'cascade', 'moe', 'few-shot', 'expert system', 'state machine', 'ontology', 'xgboost'],
      components: [
        'Expert System', 'Decision Tree', 'Rule Engine (Drools)', 'State Machine', 'Ontology',
        'Linear Regression', 'Logistic Regression', 'SVM', 'K-Nearest Neighbors',
        'Random Forest', 'XGBoost', 'Naive Bayes',
        'CNN', 'RNN', 'LSTM', 'Transformer', 'GAN', 'VAE', 'Diffusion Model', 'Graph Neural Network',
        'DQN', 'PPO', 'A3C', 'Actor-Critic Methods', 'Multi-Armed Bandit',
        'A* Search', 'Monte Carlo Tree Search', 'Genetic Algorithm', 'Simulated Annealing', 'Particle Swarm',
        'Bagging', 'Boosting', 'Stacking', 'Model Cascades', 'Mixture of Experts (MoE)', 'Few-Shot Learner'
      ]
    },
    
    'optimization': {
      name: 'Optimization & Training',
      icon: '⚙️',
      color: '#f59e0b',
      description: 'Loss functions, optimizers, and training',
      keywords: ['loss', 'optimizer', 'training', 'gradient', 'adam', 'sgd', 'rmsprop', 'adagrad', 'l-bfgs', 'lion', 'cross-entropy', 'mse', 'huber', 'contrastive', 'kl', 'ctc', 'learning rate', 'batch size', 'dropout', 'early stopping', 'rlhf', 'dpo', 'bradley', 'constitutional', 'reward', 'hyperparameter'],
      components: [
        'Cross-Entropy', 'MSE', 'Huber Loss', 'Contrastive Loss', 'KL Divergence', 'CTC Loss',
        'SGD', 'Adam', 'RMSprop', 'Adagrad', 'L-BFGS', 'Lion',
        'Bradley-Terry Model', 'PPO (for RLHF)', 'DPO', 'Constitutional AI',
        'Learning Rate Scheduler', 'Batch Size Logic', 'Dropout Rates', 'Early Stopping Criteria'
      ]
    },
    
    'deployment': {
      name: 'Deployment & Execution',
      icon: '🚀',
      color: '#f97316',
      description: 'Compilation, packaging, and execution',
      keywords: ['deploy', 'execution', 'compile', 'runtime', 'inference', 'onnx', 'tensorrt', 'openvino', 'xla', 'core ml', 'pytorch', 'tensorflow', 'jax', 'scikit', 'keras', 'quantization', 'pruning', 'distillation', 'docker', 'podman', 'conda', 'virtualenv', 'container', 'kubernetes', 'swarm', 'nomad', 'ecs', 'ci/cd', 'github actions', 'jenkins', 'gitlab', 'argocd', 'nginx', 'envoy', 'gateway', 'load balancer', 'lambda', 'serverless', 'orchestration', 'prefect', 'kubeflow'],
      components: [
        'ONNX Runtime', 'TensorRT', 'OpenVINO', 'XLA', 'Core ML',
        'PyTorch', 'TensorFlow', 'JAX', 'Scikit-learn', 'Hugging Face Transformers', 'Keras',
        'Quantization (FP16)', 'Quantization (INT8)', 'Pruning', 'Knowledge Distillation', 'Weight Clustering',
        'Docker', 'Podman', 'Conda', 'Virtualenv', 'PyPI/NPM Packages',
        'Real-time predict() API', 'Batch Scoring Scripts', 'Streaming Inference', 'On-device Execution',
        'Apache Airflow', 'Dagster', 'Prefect', 'Kubeflow Pipelines', 'AWS Step Functions',
        'Kubernetes', 'Docker Swarm', 'Nomad', 'AWS ECS',
        'Apache Kafka', 'RabbitMQ', 'AWS SQS', 'Redis Streams',
        'GitHub Actions', 'Jenkins', 'GitLab CI', 'ArgoCD',
        'Nginx', 'Envoy Proxy', 'API Gateway (Kong)', 'Load Balancer', 'Serverless Functions (Lambda)'
      ]
    },
    
    'application': {
      name: 'Application & Interface',
      icon: '💻',
      color: '#10b981',
      description: 'User-facing applications',
      keywords: ['application', 'interface', 'frontend', 'backend', 'api', 'web', 'mobile', 'fastapi', 'django', 'node', 'react', 'vue', 'html', 'css', 'streamlit', 'gradio', 'power bi', 'tableau', 'dashboard', 'chatbot', 'voice', 'copilot', 'robotic', 'trading', 'autonomous', 'agent', 'recommendation', 'session', 'a/b', 'feature flag'],
      components: [
        'Python (FastAPI)', 'Python (Django)', 'Node.js', 'Go', 'Business Logic Middleware',
        'React', 'Vue.js', 'HTML/CSS', 'Streamlit', 'Gradio', 'Power BI', 'Tableau', 'Custom Dashboard',
        'Chatbot', 'Voice Assistant', 'Copilot',
        'Robotic Control System', 'Automated Trading Algorithm',
        'Autonomous Vehicle Path Planner', 'Agentic Tool Usage',
        'Recommendation Carousel', 'Session Manager', 'A/B Testing Frame', 'Feature Flags'
      ]
    },
    
    'security': {
      name: 'Security & Privacy',
      icon: '🛡️',
      color: '#ef4444',
      description: 'Security and protection',
      keywords: ['security', 'privacy', 'encryption', 'authentication', 'authorization', 'auth', 'oauth', 'rbac', 'sso', 'network', 'air-gap', 'firewall', 'waf', 'adversarial', 'prompt injection', 'guardrail', 'safety', 'masking', 'validation', 'rate limiting'],
      components: [
        'Adversarial Training', 'Prompt Injection Firewall', 'Data Encryption (TLS/AES)',
        'Rate Limiting', 'WAF',
        'OAuth 2.0', 'RBAC', 'SSO (Okta)', 'Network Segmentation', 'Air-gapping',
        'Action Masking (RL)', 'Output Validators', 'Guardrails', 'Safety Classifiers'
      ]
    },
    
    'observability': {
      name: 'Observability & Monitoring',
      icon: '📊',
      color: '#06b6d4',
      description: 'Monitoring and tracking',
      keywords: ['monitor', 'observability', 'metric', 'alert', 'grafana', 'datadog', 'new relic', 'cloudwatch', 'drift', 'evidently', 'whylabs', 'fiddler', 'shap', 'lime', 'explain', 'trace', 'sentry', 'log', 'elk', 'lineage', 'telemetry'],
      components: [
        'Prometheus', 'Grafana', 'Datadog', 'New Relic', 'CloudWatch',
        'Evidently AI', 'WhyLabs', 'Fiddler AI', 'KS-Test', 'Population Stability Index',
        'SHAP', 'LIME', 'Integrated Gradients', 'Attention Visualization',
        'OpenTelemetry', 'Sentry', 'Log Aggregation (ELK)', 'Data Lineage Tools'
      ]
    },
    
    'governance': {
      name: 'Governance & Compliance',
      icon: '⚖️',
      color: '#14b8a6',
      description: 'Governance and policy',
      keywords: ['governance', 'compliance', 'audit', 'policy', 'regulation', 'model card', 'data card', 'git', 'blockchain', 'review', 'kill switch', 'escalation', 'eu', 'soc2', 'hipaa', 'bias', 'finops', 'portfolio', 'lifecycle'],
      components: [
        'Model Cards', 'Data Cards', 'Git Version History', 'Audit Logs (SIEM)',
        'Blockchain Timestamps',
        'Review Queue (Content Moderation)', 'Doctor-in-the-loop Dashboard',
        'Kill Switch', 'Escalation Path',
        'EU AI Act Checklist', 'SOC2 Compliance', 'HIPAA Safeguards',
        'Bias Audit Reports', 'FinOps Budgets',
        'AI Portfolio Dashboard', 'Cost-to-Serve Analytics', 'Model Lifecycle Management'
      ]
    }
  },

  // ============================================================
  // IMPLEMENTATION SEQUENCE GROUPS (Complete - covers ALL)
  // ============================================================
  
  sequenceGroups: {
    'phase-1-foundation': {
      name: 'Phase 1: Foundation & Infrastructure',
      icon: '🏗️',
      color: '#f97316',
      order: 1,
      description: 'Infrastructure and base setup',
      keywords: ['cpu', 'gpu', 'tpu', 'fpga', 'dram', 'hbm', 'ssd', 'ethernet', 'infiniband', 'power', 'cooling', 'kubernetes', 'docker', 'nginx', 'load balancer', 'hardware', 'memory', 'network'],
      components: [
        'CPU (x86)', 'CPU (ARM)', 'CPU (RISC-V)', 'GPU (NVIDIA)', 'GPU (AMD)',
        'TPU (Google)', 'FPGA', 'ASIC', 'Neuromorphic Chip', 'Quantum Processor',
        'DRAM', 'SRAM', 'HBM (High Bandwidth Memory)',
        'SSD (NVMe)', 'SSD (SATA)', 'HDD', 'Flash Storage', 'Tape Drive',
        'Ethernet', 'InfiniBand', 'PCIe Bus', 'NVLink', '5G/Wi-Fi Antennas', 'Fiber Optics',
        'Power Supply Units', 'Voltage Regulators', 'Liquid Cooling', 'Air Cooling',
        'Heat Sinks', 'Uninterruptible Power Supplies'
      ]
    },
    
    'phase-2-data': {
      name: 'Phase 2: Data Infrastructure',
      icon: '💾',
      color: '#8b5cf6',
      order: 2,
      description: 'Data storage and pipelines',
      keywords: ['database', 'storage', 'postgresql', 'mysql', 'mongo', 's3', 'pinecone', 'neo4j', 'redis', 'kafka', 'etl', 'airflow', 'pipeline', 'data'],
      components: [
        'PostgreSQL', 'MySQL', 'SQL Server', 'SQLite', 'Oracle',
        'MongoDB', 'AWS S3', 'Azure Blob Storage', 'Couchbase', 'Firebase',
        'Pinecone', 'Weaviate', 'Milvus', 'pgvector', 'FAISS', 'Chroma',
        'Neo4j', 'Amazon Neptune', 'TigerGraph', 'ArangoDB',
        'InfluxDB', 'TimescaleDB', 'Redis', 'Memcached',
        'Apache Kafka', 'AWS Kinesis', 'MQTT Broker', 'WebSocket', 'Telemetry Agent',
        'SQL SELECT Queries', 'ETL Pipeline (Airflow)', 'ETL Pipeline (Dagster)',
        'SFTP Download', 'Web Scraper (Scrapy)', 'Web Scraper (BeautifulSoup)',
        'Feature Store (Feast)', 'Feature Store (Tecton)'
      ]
    },
    
    'phase-3-processing': {
      name: 'Phase 3: Data Processing & Feature Engineering',
      icon: '🔄',
      color: '#ec4899',
      order: 3,
      description: 'Data transformation and features',
      keywords: ['processing', 'feature', 'cleaning', 'validation', 'transformation', 'encoding', 'tokenization', 'embedding', 'normalization', 'augmentation', 'prompt', 'rag'],
      components: [
        'Great Expectations', 'Pandera', 'Custom Scripts', 'Null Imputation', 'Outlier Removal',
        'One-Hot Encoding', 'Tokenization (BPE)', 'Tokenization (WordPiece)',
        'Embedding Generation', 'Normalization', 'Log Scaling',
        'PCA', 't-SNE', 'Mutual Information', 'Recursive Feature Elimination', 'Lasso Regularization',
        'Image Rotation/Cropping', 'SMOTE', 'Text Back-translation', 'Audio Noise Injection',
        'Prompt Templates', 'RAG Pipelines', 'Metadata Filtering'
      ]
    },
    
    'phase-4-model': {
      name: 'Phase 4: Model Development & Training',
      icon: '🧠',
      color: '#3b82f6',
      order: 4,
      description: 'Model building and training',
      keywords: ['model', 'ml', 'algorithm', 'neural', 'network', 'regression', 'classification', 'tree', 'forest', 'svm', 'cnn', 'rnn', 'lstm', 'transformer', 'gan', 'reinforcement', 'loss', 'optimizer', 'adam', 'training'],
      components: [
        'Expert System', 'Decision Tree', 'Rule Engine (Drools)', 'State Machine', 'Ontology',
        'Linear Regression', 'Logistic Regression', 'SVM', 'K-Nearest Neighbors',
        'Random Forest', 'XGBoost', 'Naive Bayes',
        'CNN', 'RNN', 'LSTM', 'Transformer', 'GAN', 'VAE', 'Diffusion Model', 'Graph Neural Network',
        'DQN', 'PPO', 'A3C', 'Actor-Critic Methods', 'Multi-Armed Bandit',
        'A* Search', 'Monte Carlo Tree Search', 'Genetic Algorithm', 'Simulated Annealing', 'Particle Swarm',
        'Bagging', 'Boosting', 'Stacking', 'Model Cascades', 'Mixture of Experts (MoE)', 'Few-Shot Learner',
        'Cross-Entropy', 'MSE', 'Huber Loss', 'Contrastive Loss', 'KL Divergence', 'CTC Loss',
        'SGD', 'Adam', 'RMSprop', 'Adagrad', 'L-BFGS', 'Lion',
        'Bradley-Terry Model', 'PPO (for RLHF)', 'DPO', 'Constitutional AI',
        'Learning Rate Scheduler', 'Batch Size Logic', 'Dropout Rates', 'Early Stopping Criteria'
      ]
    },
    
    'phase-5-deployment': {
      name: 'Phase 5: Deployment & Execution',
      icon: '🚀',
      color: '#f97316',
      order: 5,
      description: 'Model deployment and serving',
      keywords: ['deploy', 'execution', 'compile', 'runtime', 'inference', 'onnx', 'tensorrt', 'pytorch', 'tensorflow', 'docker', 'kubernetes', 'quantization', 'pruning', 'distillation', 'ci/cd', 'orchestration'],
      components: [
        'ONNX Runtime', 'TensorRT', 'OpenVINO', 'XLA', 'Core ML',
        'PyTorch', 'TensorFlow', 'JAX', 'Scikit-learn', 'Hugging Face Transformers', 'Keras',
        'Quantization (FP16)', 'Quantization (INT8)', 'Pruning', 'Knowledge Distillation', 'Weight Clustering',
        'Docker', 'Podman', 'Conda', 'Virtualenv', 'PyPI/NPM Packages',
        'Real-time predict() API', 'Batch Scoring Scripts', 'Streaming Inference', 'On-device Execution',
        'Kubernetes', 'Docker Swarm', 'Nomad', 'AWS ECS',
        'GitHub Actions', 'Jenkins', 'GitLab CI', 'ArgoCD',
        'Nginx', 'Envoy Proxy', 'API Gateway (Kong)', 'Load Balancer', 'Serverless Functions (Lambda)'
      ]
    },
    
    'phase-6-application': {
      name: 'Phase 6: Application Integration',
      icon: '💻',
      color: '#10b981',
      order: 6,
      description: 'Application and user interface',
      keywords: ['application', 'interface', 'frontend', 'backend', 'api', 'web', 'fastapi', 'django', 'node', 'react', 'vue', 'chatbot', 'voice', 'recommendation', 'dashboard'],
      components: [
        'Python (FastAPI)', 'Python (Django)', 'Node.js', 'Go', 'Business Logic Middleware',
        'React', 'Vue.js', 'HTML/CSS', 'Streamlit', 'Gradio', 'Power BI', 'Tableau', 'Custom Dashboard',
        'Chatbot', 'Voice Assistant', 'Copilot',
        'Robotic Control System', 'Automated Trading Algorithm',
        'Autonomous Vehicle Path Planner', 'Agentic Tool Usage',
        'Recommendation Carousel', 'Session Manager', 'A/B Testing Frame', 'Feature Flags',
        'REST API', 'Webhook', 'gRPC', 'Bluetooth/BLE', 'USB', 'File Upload',
        'Terminal/CLI Input', 'UI (Mouse/Keyboard/Touch)'
      ]
    },
    
    'phase-7-security': {
      name: 'Phase 7: Security & Governance',
      icon: '🛡️',
      color: '#ef4444',
      order: 7,
      description: 'Security, monitoring, and governance',
      keywords: ['security', 'privacy', 'encryption', 'authentication', 'oauth', 'rbac', 'firewall', 'waf', 'monitor', 'observability', 'grafana', 'prometheus', 'audit', 'compliance', 'governance', 'model card', 'kill switch'],
      components: [
        'Adversarial Training', 'Prompt Injection Firewall', 'Data Encryption (TLS/AES)',
        'Rate Limiting', 'WAF',
        'OAuth 2.0', 'RBAC', 'SSO (Okta)', 'Network Segmentation', 'Air-gapping',
        'Action Masking (RL)', 'Output Validators', 'Guardrails', 'Safety Classifiers',
        'Prometheus', 'Grafana', 'Datadog', 'New Relic', 'CloudWatch',
        'Evidently AI', 'WhyLabs', 'Fiddler AI',
        'SHAP', 'LIME', 'Integrated Gradients', 'Attention Visualization',
        'OpenTelemetry', 'Sentry', 'Log Aggregation (ELK)', 'Data Lineage Tools',
        'Model Cards', 'Data Cards', 'Git Version History', 'Audit Logs (SIEM)',
        'Blockchain Timestamps',
        'Review Queue (Content Moderation)', 'Doctor-in-the-loop Dashboard',
        'Kill Switch', 'Escalation Path',
        'EU AI Act Checklist', 'SOC2 Compliance', 'HIPAA Safeguards',
        'Bias Audit Reports', 'FinOps Budgets',
        'AI Portfolio Dashboard', 'Cost-to-Serve Analytics', 'Model Lifecycle Management'
      ]
    }
  },

  // ============================================================
  // GROUPING MODES
  // ============================================================
  
  groupingModes: {
    'none': { name: 'No Grouping', icon: '🚫', description: 'Show all components individually' },
    'type': { name: 'By Type', icon: '📦', description: 'Group by functional type' },
    'sequence': { name: 'By Sequence', icon: '📅', description: 'Group by implementation phase' }
  }
};

// ============================================================
// ENHANCED HELPER FUNCTIONS - NO COMPONENT LEFT UNASSIGNED
// ============================================================

export function findGroupForComponent(componentName, groups) {
  if (!componentName) return null;
  
  const nameLower = componentName.toLowerCase();
  
  // First pass: exact match in components list
  for (const [groupId, groupData] of Object.entries(groups)) {
    if (groupData.components && groupData.components.includes(componentName)) {
      return groupId;
    }
  }
  
  // Second pass: keyword matching
  for (const [groupId, groupData] of Object.entries(groups)) {
    if (groupData.keywords) {
      for (const keyword of groupData.keywords) {
        if (nameLower.includes(keyword.toLowerCase())) {
          return groupId;
        }
      }
    }
  }
  
  // Third pass: fuzzy matching (partial word overlap)
  const nameWords = nameLower.split(/[\s()-]+/).filter(w => w.length > 2);
  
  for (const [groupId, groupData] of Object.entries(groups)) {
    if (groupData.keywords) {
      for (const keyword of groupData.keywords) {
        const keywordWords = keyword.toLowerCase().split(/[\s-]+/);
        for (const kw of keywordWords) {
          for (const nw of nameWords) {
            if (nw.includes(kw) || kw.includes(nw)) {
              return groupId;
            }
          }
        }
      }
    }
  }
  
  return null;
}

export function getTypeGroupForComponent(componentName) {
  const groupId = findGroupForComponent(componentName, COMPONENT_GROUPINGS.typeGroups);
  if (groupId && COMPONENT_GROUPINGS.typeGroups[groupId]) {
    return { groupId, ...COMPONENT_GROUPINGS.typeGroups[groupId] };
  }
  
  // Fallback: assign to "other" group
  return {
    groupId: 'other',
    name: 'Other Components',
    icon: '📦',
    color: '#94a3b8',
    description: 'Components not categorized',
    components: []
  };
}

export function getSequenceGroupForComponent(componentName) {
  const groupId = findGroupForComponent(componentName, COMPONENT_GROUPINGS.sequenceGroups);
  if (groupId && COMPONENT_GROUPINGS.sequenceGroups[groupId]) {
    return { groupId, ...COMPONENT_GROUPINGS.sequenceGroups[groupId] };
  }
  
  // Fallback: assign to last phase (governance/security)
  const lastPhase = COMPONENT_GROUPINGS.sequenceGroups['phase-7-security'];
  return {
    groupId: 'phase-7-security',
    ...lastPhase
  };
}

export function getGroupedComponents(components, groupingMode) {
  if (groupingMode === 'none') {
    return components.map(comp => ({
      groupId: `individual-${comp.id}`,
      groupName: comp.name,
      groupIcon: comp.icon || '🔧',
      groupColor: '#94a3b8',
      components: [comp]
    }));
  }
  
  const groups = {};
  const groupsData = groupingMode === 'type' ? COMPONENT_GROUPINGS.typeGroups : COMPONENT_GROUPINGS.sequenceGroups;
  
  components.forEach(comp => {
    let groupInfo;
    if (groupingMode === 'type') {
      groupInfo = getTypeGroupForComponent(comp.name);
    } else {
      groupInfo = getSequenceGroupForComponent(comp.name);
    }
    
    const groupId = groupInfo?.groupId || 'other';
    if (!groups[groupId]) {
      groups[groupId] = {
        groupId,
        groupName: groupInfo?.name || 'Other',
        groupIcon: groupInfo?.icon || '📦',
        groupColor: groupInfo?.color || '#94a3b8',
        groupDescription: groupInfo?.description || '',
        order: groupInfo?.order || 99,
        components: []
      };
    }
    groups[groupId].components.push(comp);
  });
  
  return Object.values(groups).sort((a, b) => (a.order || 99) - (b.order || 99));
}

export default COMPONENT_GROUPINGS;